import get from "lodash/get";
import React, { useState, useEffect, Suspense, lazy } from "react";
import canUseDOM from "../../../../utils/can-use-dom";
import { connect } from "react-redux";
import { isEmpty } from "../../../utils";

function MetypeBase(props) {
  const publisherName = get(props, ["config", "publisher-name"]);
  const metypeConfig = get(props, ["config", "theme-attributes", "metype-config"], {});
  if (isEmpty(metypeConfig)) return null;
  const [feedWidget, setFeedWidget] = useState(null);
  useEffect(() => {
    async function loadFeed() {
      const Feed = await lazy(() => import(/* webpackChunkName: "metypeFeedWidget" */ "./metype-feedwidget"));
      setFeedWidget(
        <Feed
          host={metypeConfig.host}
          accountId={parseInt(metypeConfig.accountId)}
          publisher={publisherName}
          primaryColor={metypeConfig.primaryColor}
          className={metypeConfig.className || ""}
          secondaryColor={metypeConfig.bgColor}
          fontColor={metypeConfig.fontColor}
        />
      );
    }
    loadFeed();
  }, []);
  return canUseDOM ? <Suspense fallback="">{feedWidget}</Suspense> : null;
}

function mapStateToProps(state) {
  return {
    config: state.qt.config || {}
  };
}

const Metype = connect(
  mapStateToProps,
  {}
)(MetypeBase);

export { Metype };
